"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Session = void 0;
var Session;
(function (Session) {
    let RequestState;
    (function (RequestState) {
        RequestState["created"] = "created";
        RequestState["started"] = "started";
        RequestState["completed"] = "completed";
        RequestState["failed"] = "failed";
    })(RequestState = Session.RequestState || (Session.RequestState = {}));
})(Session = exports.Session || (exports.Session = {}));
//# sourceMappingURL=session.js.map